<template>
  <div>
    <component
      ref="compForm"
      :is="Currcomp"
      :orderItem="orderItem"
      :questionTypeId="questionTypeId"
      @checkSubmitStatus="checkSubmitStatus"
      @goToSuccessPage="goToSuccessPage"
      @scrollUpFormHeight="scrollUpFormHeight"
    ></component>
    <div class="action-form-button">
      <z-button-group class="btn-group">
        <div v-if="isZLJ" class="hotLine">官方客服热线4006551800</div>
        <z-button @click="confirmSubmit" :disabled="!canSubmit" type="primary">提交</z-button>
      </z-button-group>
    </div>
  </div>
</template>

<script>
import { ButtonGroup, Button } from '@zz-common/zz-ui'
import native from '@zz-common/native-adapter'
import NormalForm from './normal-form'
import C2COhterSpecialOrderForm from './c2c-other-special-order-form'
import OtherOrderForm from './other-order-form'
import C2CFakeDliveOrderForm from './c2c-fake-dlive-order-form'
import { isZlj } from '@/lib/utils'

const compMap = {
  1: NormalForm,
  2: OtherOrderForm,
  3: C2COhterSpecialOrderForm,
  4: C2CFakeDliveOrderForm
}

export default {
  name: 'ActionForm',
  props: {
    // 订单ID
    orderId: {
      type: String,
      default: ''
    },
    // 是否为订单
    isOrder: {
      type: Number,
      default: 0
    },
    // 选择的问题类型
    questionTypeId: {
      type: String,
      default: ''
    },
    // 订单所属业务线
    businessType: {
      type: String,
      default: ''
    },
    orderItem: {
      type: Object,
      default: () => {}
    },
    questionTypeItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    'z-button-group': ButtonGroup,
    'z-button': Button
  },
  computed: {
    Currcomp() {
      return this.ComputedComp()
    }
  },
  data() {
    return {
      testOrderId: '',
      testIsOrder: -1,
      testQuestionTypeId: '',
      testBusinessTypeId: '',
      canSubmit: false,
      isZLJ: isZlj()
    }
  },
  methods: {
    goToSuccessPage() {
      console.log('>>>>>>>goToSuccessPage>>>>>>>')
      // 由于表单提交页面携带needNewWebview=1，如果使用router跳转，会携带下去，导致页面无法关闭
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/complaint/success',
        needClose: 1
      })
    },
    ComputedComp() {
      // console.log('computed ActionForm has Changed this.orderId', this.orderId)
      // console.log('computed ActionForm has Changed this.businessType', this.businessType)
      // console.log('computed ActionForm has Changed this.isOrder', this.isOrder)
      // console.log('computed ActionForm has Changed this.questionTypeId', this.questionTypeId)
      // // 如果不选择订单问题，并且选择好了问题分类后
      if (this.isOrder === 2 && this.questionTypeId) {
        // 返回通用表单
        return compMap[1]
      } else {
        // 选择订单问题，并且选择问题分类以及具体订单后
        if (this.isOrder === 1 && this.questionTypeId && this.orderId) {
          const { isOtherC2CSpecialFaq = 0, isC2CFakeDliverFaq = 0 } = this.questionTypeItem
          if (isC2CFakeDliverFaq) {
            this.canSubmit = false
            return compMap[4]
          }
          if (isOtherC2CSpecialFaq) {
            this.canSubmit = false
            return compMap[3]
          }
          this.canSubmit = false
          return compMap[2]
        }
      }
      console.log(' computed ActionForm has Changed, this.orderItem ', this.orderItem)
      console.log(' computed ActionForm has Changed, this.questionTypeItem ', this.questionTypeItem)
      return null
    },
    confirmSubmit() {
      console.log('hello world', this.$refs.compForm.confirmSubmit())
    },
    checkSubmitStatus(status) {
      console.log('1234', status)
      this.canSubmit = status
    },
    scrollUpFormHeight() {
      console.log('父辈组件')
      this.$emit('scrollUpFormConHeight')
    }
  },
  created() {
    console.log('created ActionForm has Changed', this.orderId, this.businessType, this.isOrder, this.questionTypeId)
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
